// extracted by extract-css-chunks-webpack-plugin
module.exports = {"assessor-is-disabled":"assessor__assessor-is-disabled--cqcwd","assessorIsDisabled":"assessor__assessor-is-disabled--cqcwd"};